<template>
  <v-carousel
    hide-delimiters
  >
    <v-carousel-item
      v-for="item in gallery"
      :key="item"
      alt="Project Image"
    >
      <img :src="item.image" :alt="item.caption" style="object-fit: contain; width: 100%; height: 100%" class="pb-10"/>
      <div
        v-if="item.caption.length !== 0"
        class="caption"
      >
        {{ item.caption }}
      </div>
    </v-carousel-item>
  </v-carousel>
</template>

<script>

export default {
  name: 'GalleryComponent',
  props: {
    gallery: {
      type: Array,
      required: true
    }
  }
}
</script>

<style scoped>
  .caption {
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    background-color: rgba(0, 0, 0, 0.5);
    color: white;
    padding: 8px;
  }
</style>
